import {duration} from 'moment';

export class MomentUtils {

    public static getDurationFormat(start, end = moment(), type: string = 'minutes'): string {

        const val = moment(end).diff(start, type);

        switch (true) {
            /*
            case (val <= 30):
                return moment.duration(val, type).format('m');
            */
            case (val < 60):
                return moment().duration(val, type).format('m');
            case (val < 1440):
                return moment().duration(val, type).format('H');
            default:
                return moment().duration(val, type).format('D');

        }

    }

    public static getPreciseDuration(start, end = moment(), isNum: boolean = false): string {

        let s;
        let e;
        let preciseDiff;
        let durationDays;

        s = moment(start);
        e = moment(end);


        preciseDiff = moment.preciseDiff(start, end, isNum);

        durationDays = e.diff(s, 'days');

        if (durationDays >= 99) {
            preciseDiff['days'] = 99;
            preciseDiff['months'] = 0;
            return preciseDiff;
        } else {

            if (e.diff(s, 'hours') < 24) {
                return preciseDiff;
            } else {
                preciseDiff['days'] = durationDays;
                preciseDiff['months'] = 0;
                return preciseDiff;
            }

        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/utils/src/moment.utils.ts